import React from 'react';
import graphql from 'graphql';

// const Contact = ({ data }) => <h1>{data.markdownRemark.frontmatter.mission}</h1>;
const Contact = () => (
  <section className="section">
    <div className="container">
      <div className="columns is-multiline">
        <div className="column is-4 is-offset-4 center is-hidden-desktop">
          <h2 className="title is-1">Contact</h2>
        </div>
        <div className="column is-4 is-offset-4">
          We are friendly and available to contact. Reach out to us anytime and we will happily answer your question. <br />
          <br />
          <form id="contact-form" action="process.php" method="post">
            <input type="hidden" name="action" defaultValue="submit_enquiry" />
            <div className="field">
              <label className="label">Name</label>
              <div className="control">
                <input className="input" type="text" required="required" name="fullname" />
              </div>
            </div>
            <div className="field">
              <label className="label">Subject</label>
              <div className="control is-expanded">
                <div className="select is-fullwidth">
                  <select required="required" name="subject">
                    <option value="Enquiry">Enquiry</option>
                    <option value="Membership">Membership</option>
                    <option value="Promotion">Promotion</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="field">
              <label className="label">E-mail</label>
              <div className="control">
                <input className="input" type="email" required="required" name="email" />
              </div>
            </div>
            <div className="field">
              <label className="label">Phone</label>
              <div className="control">
                <input className="input" type="text" required="required" name="phone" />
              </div>
            </div>
            <div className="field">
              <label className="label">Message</label>
              <div className="control">
                <textarea className="textarea" name="comments" required="required" defaultValue={''} />
              </div>
            </div>
            <div className="g-recaptcha" data-sitekey="6LcP4EgUAAAAAAinm0UYHIYW353cGF84npWknwdj">
              <div style={{ width: 304, height: 78 }}>
                <div>
                  <iframe
                    src="https://www.google.com/recaptcha/api2/anchor?ar=1&k=6LcP4EgUAAAAAAinm0UYHIYW353cGF84npWknwdj&co=aHR0cHM6Ly9ib25nb3V0aW5kb25lc2lhLmNvbTo0NDM.&hl=en&v=v1528855115741&size=normal&cb=5c0neubsbzs6"
                    width={304}
                    height={78}
                    role="presentation"
                    frameBorder={0}
                    scrolling="no"
                    sandbox="allow-forms allow-popups allow-same-origin allow-scripts allow-top-navigation allow-modals allow-popups-to-escape-sandbox"
                  />
                </div>
                <textarea
                  id="g-recaptcha-response"
                  name="g-recaptcha-response"
                  className="g-recaptcha-response"
                  style={{ width: 250, height: 40, border: '1px solid #c1c1c1', margin: '10px 25px', padding: 0, resize: 'none', display: 'none' }}
                  defaultValue={''}
                />
              </div>
            </div>
            <div className="control center">
              <br />
              <input type="submit" className="button btn-large primary-btn common-btn" defaultValue="Send" data-label="Send" />
              <p className="form-error" style={{ display: 'none' }}>
                <br />Error submiting. Please try again.
              </p>
              {/*					<input type="text" name="_gotcha" style="display:none" /> */}
            </div>
          </form>
          <br />
          <p id="alert" style={{ fontSize: '1rem', fontWeight: 600 }}>
            &nbsp;
          </p>
        </div>
      </div>
    </div>
  </section>
);

export default Contact;

export const ContactQuery = graphql`
  query contact($path: String!) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      frontmatter {
        mission
      }
    }
    site {
      siteMetadata {
        title
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/contact.jsx